
<template>
    <div v-if="user" class="plan-page">
        <div v-if="user.role_id == roleIds.PA"  class="add-user-form-profile">
            <div class="target-main">
                <div class="medium-font-500">Hello, {{user.name ? user.name : ''}}</div></br>
                <div class="medium-font-500">The details of the student you are associated with is as under </div>
                <div class="medium-font-500">The current subscription of {{(user.students.map((x) => x.name)).toString()}} is valid till <b>{{ dateFormat()}}</b></div>
            </div>
            <div>
                <div class="target-main medium-font-500">The target exam and target year are:</div>
                <div class="target-year">
                    <div class="target-year-text-parent">
                        <div class="target-year-text medium-font-500">Target Exam:</div> 
                        <div v-if="!selectExam" class="target-year-text">
                        {{user.students[user.students.length - 1].target_exam.exam_name}}
                        </div> 
                        <v-select
                            v-if="selectExam"
                            class="select-exam"
                            ref="center"
                            v-model="selectedExam"
                            :items="examList"
                            label="Target Exam"
                            dense
                            hide-details
                            outlined
                            @change="getExam()"
                        ></v-select>
                        <v-icon
                            class="pencil-icon"
                            @click="editTargetExam()"
                            >mdi-pencil</v-icon
                        >
                    </div>
                    
                </div>
                <div class="target-year">
                    <div class="target-year-text-parent">
                        <div class="target-year-text medium-font-500">Target Year:</div>   
                        <div v-if="!selectTarget" class="target-year-text">
                            {{user.students && user.students.length && user.students[user.students.length - 1].target_exam && user.students[user.students.length - 1].target_exam.exam_year_name}}
                        </div> 
                        <div class="">
                        <v-select 
                            v-if="selectTarget"
                            class="select-exam"
                            ref="center"
                            v-model="selectedYear"
                            :items="yearList"
                            label="Target Exam Year"
                            dense
                            hide-details
                            outlined
                            @change="getYear()"
                        ></v-select>
                    </div>
                    </div>
                    
                </div>
                
            </div>
            <v-row>
                <v-col cols="12" sm="4" class="rg-center b-data">
                    <v-btn @click="onSubmit()" class="right-btn cust-btn" color="primary">Done</v-btn>
                </v-col>
                <v-col cols="12" sm="4" class="blk"></v-col>
                <v-col cols="12" sm="4" class="blk"></v-col>
            </v-row>
        </div>
        <div v-else class="add-user-form-profile">
            <div  class="target-main">
                <div class="medium-font-500">Hello,</div></br>
                <div class="medium-font-500">The current subscription of {{user.name ? user.name : ''}} is valid till <b>{{ dateFormat() }}</b></div>
            </div>
            <div>
                <div class="target-main medium-font-500">The target exam and target year are:</div>
                <div class="target-year">
                    <div class="target-year-text-parent">
                        <div class="target-year-text medium-font-500">Target Exam:</div> 
                        <div v-if="!selectExam" class="target-year-text">
                            {{user.target_exam && user.target_exam.exam_name ? user.target_exam.exam_name : ''}}
                        </div> 
                        <v-select
                            v-if="selectExam"
                            class="select-exam"
                            ref="center"
                            v-model="selectedExam"
                            :items="examList"
                            label="Target Exam"
                            dense
                            hide-details
                            outlined
                            @change="getExam()"
                        ></v-select>
                        <v-icon
                            class="pencil-icon"
                            @click="editTargetExam()"
                            >mdi-pencil</v-icon
                        >
                    </div>
                    
                </div>
                <div class="target-year">
                    <div class="target-year-text-parent">
                        <div class="target-year-text medium-font-500">Target Year:</div>   
                        <div v-if="!selectTarget" class="target-year-text">
                            {{user.target_exam ? user.target_exam.exam_year_name : ''}}
                        </div> 
                        <div class="">
                        <v-select 
                            v-if="selectTarget"
                            class="select-exam"
                            ref="center"
                            label="Target Exam Year"
                            v-model="selectedYear"
                            :items="yearList"
                            dense
                            hide-details
                            outlined
                            @change="getYear()"
                            filled
                        ></v-select>
                    </div>
                    </div>
                    
                </div>
                
            </div>
            <v-row>
                <v-col cols="12" sm="4" class="rg-center b-data">
                    <v-btn @click="onSubmit()" class="right-btn cust-btn" color="primary">Done</v-btn>
                </v-col>
                <v-col cols="12" sm="4" class="blk"></v-col>
                <v-col cols="12" sm="4" class="blk"></v-col>
            </v-row>
        </div>
        <AlertBox
        :width="modalwidth"
        :onClose="onClose"
        :component="cComponent"
        :status="status"
        :data="alertData"
      />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
import moment from "moment";
export default {
    name: "TargetExam",
    props: ["tab"],
    computed: {
        ...mapState("userStore", ["user"])
    },
    data() {
        return {
            status: false,
            examList: [],
            yearList: [],
            selectedExam: null,
            selectedYear: null,
            selectTarget: false,
            selectExam: false,
            alertData:{},
            cComponent: "",
            modalwidth: null,
            alertData: {},
            onPopUpTermsAndConditions: false,
            isTargetExam: false,
        };
    },
    methods: {
        ...mapActions({
            me: "userStore/me",
            updateProfile: "userStore/updateProfile",
            getCenters: "utilStore/getCenters",
            getBatchesByCenters: "utilStore/getBatchesByCenters",
            getSubscriptionImpact: "utilStore/getSubscriptionImpact",
        }),
        showPricingDetails(data) {
            this.alertData = {};
            if(data.subscription && data.subscription.imapact){
                this.alertData.subscription = data.subscription
            }
            this.alertData.showPricingDetails = data.showPricingDetails
            this.alertData.subscriptionDate = data.subscriptionDate
            this.modalwidth = "470px";
            this.status = true;
            this.cComponent = "components/profile/InformationPopup";
        },
        showSubscriptionDetails(response) {
            let selectedExam = this.selectedExam;
            let selectedYear = this.selectedYear;
            let selectedExamObj =this.examList.find((x) => x.value == selectedExam)
            this.alertData = {
                previousExam: this.user.center_name,
                selectedExamName: selectedExamObj ? selectedExamObj.text : "" ,
                selectedExam: selectedExam,
                selectedYear: selectedYear,
                subscription: {...response},
            };
            if(response.subscription && response.subscription.imapact){
                this.alertData.subscription = response.subscription
            }
            this.alertData.persistent = true;
            this.modalwidth = "470px";
            this.status = true;
            this.cComponent = "components/profile/PriceDetailModal";
        },
        onSubmit() {
            let selectedExam = this.selectedExam;
            let exam_id = this.isTargetExam ? this.user.target_exam.exam_id : '';
            let selectedExamObj =this.examList.find((x) => x.value == selectedExam || x.value == exam_id)
            if (this.validate()) {
                
                let reqData = {
                        new_target_exam: selectedExamObj ? selectedExamObj.text : ""
                    };
                    if(this.user && this.user.role_id == this.roleIds.PA){
                        let id = this.user.students && this.user.students.length && this.user.students[this.user.students.length - 1].id;
                        reqData.parent_student_id = id;
                    }
                this.loading = true;
                if(this.selectedExam && this.selectedExam !== exam_id){
                    this.getSubscriptionImpact(reqData)
                    .then((response) => {
                        this.showSubscriptionDetails(response);
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
                }else{
                     let formdata = new FormData();
                        formdata.append("reqData[batch_id]", parseInt(this.selectedYear));
                        formdata.append("reqData[center_id]",parseInt(this.selectedExam ? this.selectedExam : exam_id));
                        if(this.user && this.user.role_id == this.roleIds.PA){
                            formdata.append("reqData[parent_student_id]",this.user.students[this.user.students.length - 1].id)
                        }
                    this.updateProfile(formdata)
                    .then(response => {
                        this.$toasted.success(`Exam data updated successfully`, {
                            icon: "check_circle"
                        });
                        this.me();
                        this.onClose({ status:false, isReload: true})
                    })
                    .catch(err => {});
                }
                
            }
            
        },
        onClose(data) {
            if(data.showPricingDetails && !this.onPopUpTermsAndConditions){
                this.showPricingDetails(data);
                this.onPopUpTermsAndConditions = true;
            }
            else if (data && this.onPopUpTermsAndConditions) {
                this.showSubscriptionDetails(data)
                this.onPopUpTermsAndConditions = false;
            }
            else {
                this.status = data.status;
                if (!data.status && data.isReload) {
                    this.selectTarget = false;
                    this.selectExam = false;
                }
            }
        },
        validate() {
            let isValid = true;
            if (!this.selectedYear) {
                this.$toasted.error("Please select Target Year")
                isValid = false;
            }
            return isValid;
        },
        dateFormat() {
            let boostup = this.user && this.user.subscription_details && this.user.subscription_details.length && this.user.subscription_details.find((x)=> x.name == 'Boost Up'); 
            if(boostup && boostup.expiry_date){
                return moment(boostup.expiry_date).format("DD-MMM-YY");
            }else{
                return "";
            }
        },
        getExam() {
            let reqData = {
                instituteId: constants.ONLINE_INSTITUTE_ID
            };
            this.getCenters(reqData)
                .then((response) => {
                this.examList = response.map((x) => {
                    let d = {};
                    d.text = x.name;
                    d.value = x.id;
                    return d;
                });
                this.getYear();
            })
                .catch((err) => {
                console.log(err);
            });
        },
        editTargetExam() {
            this.selectExam = !this.selectExam;
            this.selectTarget = !this.selectTarget;
            this.getExam();
        },
        getYear() {
            let exam_id = this.isTargetExam ? this.user.target_exam.exam_id : '';
            if (this.selectedExam || exam_id) {
                
                let reqData = {
                    center_id: this.selectedExam ? [this.selectedExam] : [exam_id],
                };
                this.getBatchesByCenters(reqData)
                    .then((response) => {
                    this.yearList = response.list.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        return c;
                    });
                })
                    .catch((err) => {
                    console.log(err);
                });
            }
        },
    },
    mounted(){
        this.isTargetExam = this.user && this.user.target_exam ? true : false;
        this.selectedYear = this.isTargetExam ? this.user.target_exam.exam_year_id : '';
        this.selectedExam = this.isTargetExam ? this.user.target_exam.exam_id : '';
    }
};
</script>
